export enum EnaioUpdateMultipleStrategy {
    error = 0,
    updateLowestId = 1,
    updateHighestId = 2
}
export namespace EnaioUpdateMultipleStrategy{
    export function getName(value: EnaioUpdateMultipleStrategy): string {
        switch (value) {
            case EnaioUpdateMultipleStrategy.error:
                return "error";
            case EnaioUpdateMultipleStrategy.updateLowestId:
                return "updateLowestId";
            case EnaioUpdateMultipleStrategy.updateHighestId:
                return "updateHighestId";
        }
    }
}
